import get from 'lodash/get';

export const getCurrentFiltersFromNewSearchParams = (newFilters, searchParameters) => {
  let currentFilters = get(searchParameters, 'filters');

  Object.keys(newFilters).forEach(key => {
    const value = newFilters[key];

    if (key === 'region') {
      const { city, city_area: cityArea, ...newCurrentFilters } = currentFilters;
      currentFilters = newCurrentFilters;
    }

    if (key === 'city') {
      const { city_area: cityArea, ...newCurrentFilters } = currentFilters;
      currentFilters = newCurrentFilters;
    }

    if (value !== '' && parseInt(value, 10) !== 0 && value !== false) {
      currentFilters = { ...currentFilters, [key]: value };
    } else {
      const { [key]: unusedKey, ...newCurrentFilters } = currentFilters;
      currentFilters = newCurrentFilters;
    }
  });
  return currentFilters;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/getCurrentFiltersFromNewParams.js